export default {


    currentProjectData: null,
    originalProjectData: null,

}
